const data = {
  text: 'Jetzt Erstgespräch vereinbaren',
  subline: 'Hier klicken, um Termin zu vereinbaren',
  link: 'Kostenfrei & unverbindlich',
  url: {
    to: '/termin-buchen',
    internalLink: true
  }
}

export default data
